import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorage_AuthToken } from '../constants/constants';
import { TenantIdService } from '../services/tenant-id.service';
import { map, share, startWith } from 'rxjs/operators';
import { TenantIdentifierInfo } from '../interfaces/tenant.interfaces';

@Injectable({
    providedIn: 'root',
})
export class HasAccessTokenGuard implements CanActivate {
    constructor(
        private router: Router,
        private tenantIdService: TenantIdService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean | UrlTree> {
        const token = localStorage.getItem(LocalStorage_AuthToken);

        const minExpectedJwtTokenLength = 1000;
        if (token !== null && token !== undefined && token.length > minExpectedJwtTokenLength)
            return true;

        return this.tenantIdService.tenantId
        .pipe(
            map(tenantIdInfo => {
                const tenantIdPath = tenantIdInfo.source == 'path' ? '/t/' + tenantIdInfo.name : '';
                return this.router.parseUrl(tenantIdPath + '/start');
            })
        );
    }
}
